// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ContributionBatch } from './contribution-batch';
import { ContributionCash } from './contribution-cash';
import { ContributionLine } from './contribution-line';
import { ContributionType } from './contribution-type';
import { Person } from './person';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Contribution extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get totalAmount() {
        if (this.lines && this.lines.length > 0) {
            let total = 0;
            this.lines.forEach((line) => {
                total += line.amount;
            });
            return Math.round(total * 100) / 100;
        } else return 0;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  batchId!: number;
  checkNumber?: string;
  created?: Date;
  createdBy?: string;
  modified?: Date;
  modifiedBy?: string;
  notDeductible!: boolean;
  note?: string;
  personId!: number;
  rmdContribution!: boolean;
  rowVersion?: number;
  typeId?: number;
  batch!: ContributionBatch;
  cashCounts!: ContributionCash[];
  lines!: ContributionLine[];
  person!: Person;
  type!: ContributionType;
}

